/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AdministrationRole {
  None = 0,
  DepartmentAdministration = 1,
  CaseManagerAdministration = 2,
  CustomerAdministration = 4,
  SlaAdministration = 8,
  FinancialsAdministration = 16,
  NoExpUnitAdministration = 32,
  WarrantyAdministration = 64,
  TransitAdministration = 128,
  CaseAdministration = 256,
  InvoiceDataApiAdministration = 512,
  All = 1023,
}
